import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const holidaysListClient = async () => {
  const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.holidaysList()}`;
  const res = await fetch(url);

  if (!res.ok) {
    return { error:true, message: 'Holidays List request failed', status: res.status, data: [] };
  }
  const getData = await res.json();
  return { status: res.status, data: getData };
};

export default holidaysListClient;
